(() => {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const init = () => {
    const root = document.querySelector('[data-prx-root]');
    if (!root || root.dataset.prxReady === 'true') return;
    root.dataset.prxReady = 'true';

    const loader = root.querySelector('[data-prx-loader]');
    const progressBar = root.querySelector('[data-prx-progress]');
    const nav = root.querySelector('[data-prx-nav]');
    const heroMedia = root.querySelector('[data-prx-hero-media]');
    const craft = root.querySelector('[data-prx-craft]');
    const craftImages = Array.from(root.querySelectorAll('[data-prx-craft-image]'));
    const craftCopies = Array.from(root.querySelectorAll('[data-prx-craft-copy]'));
    const craftSteps = Array.from(root.querySelectorAll('.prx-craft__steps i'));
    const craftIndex = root.querySelector('[data-prx-craft-index]');
    const craftScan = root.querySelector('[data-prx-craft-scan]');
    const runway = root.querySelector('[data-prx-runway]');
    const productTrack = root.querySelector('[data-prx-product-track]');
    const mobileBar = root.querySelector('.prx-mobile-bar');
    const categoryImages = Array.from(root.querySelectorAll('.prx-category img'));
    const brandFilm = root.querySelector('[data-prx-brand-film]');
    const brandFilmImage = brandFilm?.querySelector(':scope > img');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let activeCraft = -1;

    const setCraftStage = (next) => {
      if (next === activeCraft) return;
      activeCraft = next;
      craftImages.forEach((item, index) => item.classList.toggle('is-active', index === next));
      craftCopies.forEach((item, index) => item.classList.toggle('is-active', index === next));
      craftSteps.forEach((item, index) => item.classList.toggle('is-active', index === next));
      if (craftIndex) craftIndex.textContent = `0${next + 1} / 03`;
    };

    const parallaxImage = (image, strength) => {
      if (!image || reduceMotion.matches) return;
      const rect = image.parentElement.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;
      const center = rect.top + rect.height / 2;
      const offset = clamp((window.innerHeight / 2 - center) / window.innerHeight, -1, 1) * strength;
      image.style.setProperty('--prx-image-shift', `${offset}px`);
    };

    const update = () => {
      const y = window.scrollY;
      const viewport = window.innerHeight;
      const pageDistance = Math.max(1, document.documentElement.scrollHeight - viewport);

      if (progressBar) progressBar.style.width = `${(y / pageDistance) * 100}%`;
      nav?.classList.toggle('is-solid', y > 32);
      mobileBar?.classList.toggle('is-visible', y > viewport * .72);

      if (heroMedia && !reduceMotion.matches) {
        const heroProgress = clamp(y / viewport);
        heroMedia.style.transform = `translate3d(0,${heroProgress * 105}px,0) scale(${1.04 - heroProgress * .02})`;
      }

      if (craft) {
        const rect = craft.getBoundingClientRect();
        const distance = Math.max(1, craft.offsetHeight - viewport);
        const craftProgress = clamp(-rect.top / distance);
        const next = Math.min(craftImages.length - 1, Math.floor(craftProgress * craftImages.length));
        setCraftStage(Math.max(0, next));
        if (craftScan) {
          if (window.innerWidth >= 990) {
            craftScan.style.top = '0';
            craftScan.style.left = `${craftProgress * 100}%`;
          } else {
            craftScan.style.left = '0';
            craftScan.style.top = `${craftProgress * 100}%`;
          }
        }
      }

      if (runway && productTrack && !reduceMotion.matches) {
        const rect = runway.getBoundingClientRect();
        const distance = Math.max(1, runway.offsetHeight - viewport);
        const runwayProgress = clamp(-rect.top / distance);
        const sideGap = window.innerWidth >= 990 ? window.innerWidth * .055 : 12;
        const travel = Math.max(0, productTrack.scrollWidth - window.innerWidth + sideGap);
        productTrack.style.transform = `translate3d(${-travel * runwayProgress}px,0,0)`;
      }

      categoryImages.forEach((image) => parallaxImage(image, 34));

      if (brandFilm && brandFilmImage && !reduceMotion.matches) {
        const rect = brandFilm.getBoundingClientRect();
        if (rect.bottom > -100 && rect.top < viewport + 100) {
          const center = rect.top + rect.height / 2;
          const shift = clamp((viewport / 2 - center) / viewport, -1, 1) * 58;
          brandFilmImage.style.setProperty('--prx-film-shift', `${shift}px`);
        }
      }

      frame = 0;
    };

    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    if ('IntersectionObserver' in window && !reduceMotion.matches) {
      root.classList.add('prx-motion-ready');
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        }),
        { threshold: .06, rootMargin: '0px 0px -3% 0px' },
      );

      root.querySelectorAll('[data-prx-reveal]').forEach((element) => observer.observe(element));
    }
    setCraftStage(0);
    update();

    window.setTimeout(() => root.classList.add('is-ready'), 560);
    window.setTimeout(() => loader?.classList.add('is-hidden'), 1200);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    reduceMotion.addEventListener?.('change', requestUpdate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
